import { Map2 } from "src/modules/utils/shared/map2.model";
import { DataSource } from "./data-source.model";
import { RestEndpoint } from "src/modules/sm-base/models/rest-endpoint.model";
import { EnaioDataSource } from "./enaio-data-source.model";
import { DataSourceItem } from "./data-source-item.model";

export class DataSourceHandler {

    definitions: EnaioDataSource[] = [];

    private ds = new Map2<string, DataSource>();

    constructor(definitions: EnaioDataSource[]) {
        this.definitions = definitions;
    }

    async getOrFetch(dataSourceId: string): Promise<DataSource> {
        if (!this.ds.has(dataSourceId)) {
            let def = this.definitions.find(def => def.id == dataSourceId);
            this.ds.set(dataSourceId, new DataSource(def, def.backendOnly ? [] :
                await RestEndpoint.main().query({formId: "invoice", dataSourceId: dataSourceId}).run("api/ivg/queryDataSource").list(DataSourceItem)));
        }
        return this.get(dataSourceId);
    }

    get(dataSourceId: string): DataSource {
        return this.ds.get(dataSourceId);
    }
}